import { addDays } from 'date-fns';

import type { RequestTask } from './requestTasks';

import { isLiveTask } from './requestTasks';

export const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function startOfUtcDay(date: Date) {
  return new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
  );
}

export function parseIsoDate(value: string | null | undefined) {
  if (!value) return null;
  const parsed = new Date(`${value.slice(0, 10)}T00:00:00.000Z`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export interface RequestDeadlineInput {
  createdAt: Date;
  tasks: RequestTask[];
}

export interface RequestDeadlineLeadDays {
  requestDueDefaultDays: number;
}

/**
 * The earliest due date across the request's open, visible tasks, or a synthetic
 * deadline `requestDueDefaultDays` after it was raised. A request always ends up
 * with a deadline — a request with nothing dated is still work someone is
 * waiting on.
 *
 * Lead days are injected rather than read from a hook so this stays pure and
 * unit-testable against a frozen clock.
 */
export function effectiveRequestDeadline(
  input: RequestDeadlineInput,
  leadDays: RequestDeadlineLeadDays,
) {
  const dueTimes = input.tasks
    .filter(isLiveTask)
    .map((task) => task.dueAt?.getTime())
    .filter((time): time is number => time != null);

  if (dueTimes.length > 0) {
    return new Date(Math.min(...dueTimes));
  }
  return addDays(input.createdAt, leadDays.requestDueDefaultDays);
}
